export default __webpack_public_path__ + "static/media/gallery-wip-emitter_08.81245d82.jpg";